import Fuse from 'fuse.js';
import { useAllProductsSearch } from './useAllProductsSearch';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';

export function useSearch(query: string, resultLength = 30) {
    const { currentLocale } = usePageLocalization();
    const [allProducts] = useAllProductsSearch();

    const fuse = new Fuse(allProducts as Queries.ProductsJson[], {
        shouldSort: true,
        ignoreLocation: true,
        threshold: 0.3,
        keys: [
            {
                name: `code`,
                weight: 2,
            },
            { name: `description.${currentLocale}`, weight: 0.5 },
            {
                name: `title.${currentLocale}`,
                weight: 1.5,
            },
            { name: `category_localized.${currentLocale}`, weight: 1 },
        ],
        isCaseSensitive: false,
    });

    let matchingProducts: Queries.ProductsJson[] = [];

    if (query === '') {
        matchingProducts = [];
    } else {
        matchingProducts = fuse
            .search(query, {
                limit: resultLength, // default to 30
            })
            .filter((searchResult) => currentLocale != 'en_US' || !searchResult.item.attributes?.available_country || JSON.stringify(searchResult.item.attributes?.available_country?.values).includes('United States'))
            .map((searchResult) => searchResult.item);
    }

    return { results: matchingProducts };
}
